import React from 'react';

function WalletAddressTutorial() {
  return (
    <div className="tutorial-section" style={{
      background: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '8px',
      padding: '20px',
      margin: '20px 0'
    }}>
      <h3 style={{ color: '#495057', marginBottom: '15px' }}>📱 新手教程：如何获取钱包地址</h3>
      
      <div className="tutorial-steps">
        <div className="tutorial-step" style={{ marginBottom: '20px' }}>
          <h4 style={{ color: '#007bff', marginBottom: '10px' }}>步骤1: 点击币安钱包右上角的"接收"按钮</h4>
          <div style={{ textAlign: 'center', marginBottom: '10px' }}>
            <img 
              src="/images/binance-wallet-receive.png"
              alt="币安钱包接收按钮"
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{ 
              display: 'none', 
              padding: '40px', 
              backgroundColor: '#f8f9fa', 
              border: '2px dashed #dee2e6',
              borderRadius: '5px',
              color: '#6c757d',
              textAlign: 'center'
            }}>
              📱 请将币安钱包"接收"按钮的截图保存为 /public/images/binance-wallet-receive.png
            </div>
          </div>
          <p style={{ color: '#6c757d', fontSize: '14px' }}>
            在币安钱包主界面，点击右上角绿色的"接收"按钮
          </p>
        </div>

        <div className="tutorial-step">
          <h4 style={{ color: '#007bff', marginBottom: '10px' }}>步骤2: 选择BNB Smart Chain网络并复制地址</h4>
          <div style={{ textAlign: 'center', marginBottom: '10px' }}>
            <img 
              src="/images/binance-wallet-networks.png"
              alt="选择BNB Smart Chain"
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{ 
              display: 'none', 
              padding: '40px', 
              backgroundColor: '#f8f9fa', 
              border: '2px dashed #dee2e6',
              borderRadius: '5px',
              color: '#6c757d',
              textAlign: 'center'
            }}>
              📱 请将币安钱包网络选择界面的截图保存为 /public/images/binance-wallet-networks.png
            </div>
          </div>
          <p style={{ color: '#6c757d', fontSize: '14px' }}>
            选择"BNB Smart Chain"网络，然后点击复制按钮复制你的钱包地址，粘贴到上面的输入框中
          </p>
        </div>
      </div>
    </div>
  );
}

export default WalletAddressTutorial; 